<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-back-button data-test="backButton"></ion-back-button>
        </ion-buttons>
        <ion-title data-test="title" #title (click)="onTitleClick()">Reports</ion-title>
        <!-- <ion-buttons slot="end">
            <ion-button [disabled]=vb.disabled color="light" id="more" (click)="onMoreClick($event)">
                <ion-icon name="ellipsis-horizontal"></ion-icon>
            </ion-button>
        </ion-buttons> -->
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-list>
        <ion-list-header color="secondary">
            Date Range Selection - Step 2 of 3
        </ion-list-header>

        <ion-item-divider color="tertiary">
            Select Date Range For: {{vm.selectedReport.title}}
        </ion-item-divider>

        <ion-item data-test="startingDateItem" detail="true" (click)="onStartingReportDateClick()" href="javascript:;">
            <ion-label>
                <span class="line1">Starting Report Date</span><br />
                <span class="line2">{{selectedStartDate | myTimestamp : 'EEEE, MMMM dd yyyy'}}</span>
            </ion-label>
        </ion-item>

        <ion-item data-test="endingDateItem" detail="true" (click)="onEndingReportDateClick()" href="javascript:;">
            <ion-label>
                <span class="line1">Ending Report Date</span><br />
                <span class="line2">{{selectedEndDate | myTimestamp : 'EEEE, MMMM dd yyyy'}}</span>
            </ion-label>
        </ion-item>
    </ion-list>
    
    <ion-fab vertical="bottom" horizontal="end">
        <ion-fab-button data-test="nextButton" [disabled]=vb.disabled title="Next" (click)="onNextClick()">
            <ion-icon name="chevron-forward"></ion-icon>
        </ion-fab-button>
    </ion-fab>
</ion-content>